/** @flow */
import React from "react";
import { localize } from "redux-i18n";
import actionCreators from "@modules/client/actionCreator";
import { Modal, ModalHeader, ModalBody, Button, ModalFooter, Col } from "@components";
import { SchemaForm } from "@components";
import { FormHeader } from "@modules/client/components";
import type { EffectiveUserPermissions } from "@modules/service/reducer/user-permissions/types";
import { uiSchema } from "./ui-schema";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: Object,
  schema: Object,
  toggleModal: Function,
  updateUserPermissions: EffectiveUserPermissions => void,
  title: string,
  name: string,
  submitForm?: Function,
}>;

type State = $Exact<{
  formData: Object,
}>;

export class UserPermissionsEditModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }
  state = {
    formData: this.props.data,
  };

  submitForm = () => {
    this.formRef.current.submit();
  };

  submitHandler = (formData: Object) => {
    this.props.updateUserPermissions(formData);
  };

  onChange = (formData: Object) => {
    this.setState({
      formData: formData,
    });
  };

  render() {
    const uiSchemaForm = uiSchema(this.props.t, this.state.formData);
    return (
      <Modal className="modal-small">
        <ModalHeader tag="h3" toggle={this.props.toggleModal}>
          {this.props.title}
        </ModalHeader>
        <ModalBody>
          <FormHeader title="" />
          <SchemaForm
            externalSubmit
            schema={this.props.schema}
            formData={this.state.formData}
            uiSchema={uiSchemaForm[this.props.name]}
            onChange={this.onChange}
            ref={this.formRef}
            onSubmit={this.submitHandler}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.toggleModal}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(UserPermissionsEditModal);
